import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {AuthGuardService} from "../../shared/services/auth-guard.service";
import {tap} from "rxjs/operators/tap";
import {catchError} from "rxjs/operators/catchError";
import 'rxjs/add/observable/throw';
import { Router } from '@angular/router'

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private injector: Injector,
    private router: Router
  ) {}

  //intercept(httpRequest: HttpRequest<any>, httpHandler: HttpHandler): Observable<HttpEvent<any>> {
  //
  //  let authGuardService = this.injector.get(AuthGuardService);
  //  let token = authGuardService.getAccessToken();
  //
  //  if(token){
  //    httpRequest = httpRequest.clone({
  //      setHeaders: {
  //        Authorization: `Bearer ${token}`
  //      }
  //    });
  //  }
  //  return httpHandler.handle(httpRequest);
  //}

  intercept(httpRequest: HttpRequest<any>, httpHandler: HttpHandler): Observable<HttpEvent<any>> {
    let body: string = httpRequest.body
    if(body && typeof body == "string" && body.startsWith("grant_type") || !httpRequest.url.startsWith("http")){
      return httpHandler.handle(httpRequest)
        .pipe(
          tap(data => {}),
          catchError(this.handleError('getData'))
        );
    }

    let authGuardService = this.injector.get(AuthGuardService);
    let token = authGuardService.getAccessToken();

    if(token){
      httpRequest = this.setToken(httpRequest, token)

      let isExpired = authGuardService.isExpired()
      if(isExpired){
        return authGuardService.doRefreshToken().flatMap(data => {
          authGuardService.saveToken(data)
          token = authGuardService.getAccessToken()
          httpRequest = this.setToken(httpRequest, token)
          return httpHandler.handle(httpRequest)
            .pipe(
              tap(data => {}),
              catchError(this.handleError('getData'))
            );
        })
      }
    }

    return httpHandler.handle(httpRequest)
      .pipe(
        tap(data => {}),
        catchError(this.handleError('getData'))
      );
  }

  private setToken(httpRequest: HttpRequest<any>, token){
    return httpRequest.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private handleError(operation: String) {
    return (err: any) => {
      let errMsg = 'Error'
      if(err instanceof HttpErrorResponse) {
         errMsg = err.message
      }

      const /** @type {?} */ extras = {
        message: err.message,
        errorMessage: err.error.error,
      };

      this.router.navigate(['error', extras])
      return Observable.throw(errMsg);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/modules/bypass/token.interceptor.ts